<template>
<section class="services-section">
  <div class="container">
    <div class="service-card">
      <h2>Afterwork</h2>
      <p>
        Arbetsdagen är slut, och det är dags att njuta. Hos oss hittar du den perfekta platsen för att varva ner, umgås med kollegor eller dela trevliga stunder med vänner.      </p>
      <router-link to="/afterwork" class="btn">AW Meny</router-link>
    </div>
    <div class="service-card">
      <h2>Mat</h2>
      <p>
        Upptäck vår matmeny fylld med noggrant utvalda rätter som passar alla smaker. Från klassiska favoriter till spännande vegetariska alternativ – en smakupplevelse att dela med goda vänner.      </p>
      <router-link to="/meny/matmeny" class="btn">Matmeny</router-link>
    </div>
    <div class="service-card">
      <h2>Bar</h2>
      <p>
        Slå dig ner vid vår bar och njut av stämningen! Oavsett om du föredrar en kall öl eller en av våra utsökta cocktails, har vi något för alla. Här är du alltid välkommen.      </p>
      <router-link to="/meny/drinklista" class="btn">Drinklista</router-link>
    </div>
  </div>
</section>

</template>

<style>
/* Bakgrund och layout */
.services-section {
  background: #1a1a1a; /* Mörkare bakgrundston */
  padding: 4rem 1rem;
  text-align: center;
  font-family: 'Lato', sans-serif;
}

.container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 2rem; /* Mellanrum mellan korten */
}

/* Kortdesign */
.service-card {
  background: #1c1c1c; /* Mörk bakgrund för korten */
  border: 1px solid #937d51; /* Guldaktig ram */
  border-radius: 8px;
  padding: 2rem;
  max-width: 300px;
  color: #f5f5f5;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.service-card:hover {
  transform: translateY(-10px); /* Lyft kortet något vid hover */
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.5);
}

/* Rubriker */
.service-card h2 {
  font-size: 1.8rem;
  font-weight: 700;
  margin-bottom: 1rem;
  color: #937d51; /* Guld för rubriker */
}

/* Text */
.service-card p {
  font-size: 1rem;
  line-height: 1.6;
  margin-bottom: 2rem;
  color: #ddd;
}

/* Knappar */
.btn {
  display: inline-block;
  background: #937d51; /* Guldknapp */
  color: #111; /* Kontrastfärg för text */
  padding: 0.8rem 1.5rem;
  border-radius: 4px;
  font-size: 1rem;
  font-weight: 600;
  text-decoration: none;
  transition: background 0.3s ease, transform 0.2s ease;
}

.btn:hover {
  background: #b89e6b; /* Ljusare guld på hover */
  transform: scale(1.05);
}
</style>
